import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import ContentBox from '../../components/ContentBox';
import { FrankoPopLayout, ActivityRow, EmptyState, Pagination } from '../../components/frankopop/frankopopShared';
import { useFrankopopData, fetchWallet, fetchActivity } from '../../data/frankopop';

const PAGE_SIZE = 20;

export default function FrankoPopActivity({ userData }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Math.max(1, parseInt(searchParams.get('page'), 10) || 1);

    const walletFetch = useCallback(() => (userData ? fetchWallet() : Promise.resolve(null)), [userData]);
    const { data: walletData } = useFrankopopData(walletFetch, null);

    const activityFetch = useCallback(() => fetchActivity(page, PAGE_SIZE), [page]);
    const { data, loading, error } = useFrankopopData(activityFetch, null);

    const goToPage = (next) => {
        if (!data || next < 1 || next > data.totalPages) return;
        setSearchParams(next === 1 ? {} : { page: String(next) });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <FrankoPopLayout active="activity" wallet={walletData ? walletData.cards : null}>
            <ContentBox theme="default" tint="steelblue" header="FrankoPop activity">
                <p className="text-sm text-gray-600 mb-3">
                    Every FrankoPop pulled from a box or taken out of its packaging, newest first.
                </p>
                {loading && !data ? (
                    <p className="text-sm text-gray-500">Loading activity...</p>
                ) : error ? (
                    <p className="text-sm text-red-600">Couldn&apos;t load activity - {error}</p>
                ) : !data || data.events.length === 0 ? (
                    <EmptyState title="No activity yet" sub="Nobody has opened a FrankoPop yet - be the first!" />
                ) : (
                    <>
                        <div className={`space-y-2 ${loading ? 'opacity-60' : ''}`}>
                            {data.events.map((event) => <ActivityRow key={event.id} event={event} />)}
                        </div>
                        <Pagination page={data.page} totalPages={data.totalPages} total={data.total} onChange={goToPage} />
                    </>
                )}
            </ContentBox>
        </FrankoPopLayout>
    );
}
